import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { PapanLaporanList } from '../../../../components/PapanLaporanList'

export const Route = createFileRoute('/desa/$slug/laporan/')({
  component: PapanLaporanListPage,
})

function PapanLaporanListPage() {
  const { slug } = Route.useParams()
  useEffect(() => {
    const name = slug.replace(/-/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
    document.title = `Papan Laporan — Desa ${name}`
    return () => {
      document.title = 'Desa Platform — Asisten Digital Desa'
    }
  }, [slug])
  return <PapanLaporanList slug={slug} />
}
